require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-oberwart-unterwart.json") })
        }
      }, "path---betreuungseinrichtungen-oberwart-unterwart");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-oberwart-unterwart!./.cache/json/betreuungseinrichtungen-oberwart-unterwart.json
// module id = 1028
// module chunks = 231608221292675